import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getMessages: () => ApiUtils.responseParser(Axios.get('/web/v1/messages')),
  modifyMessage: (message) => Axios.put('/web/v1/messages/' + message.id, message).then(() => null),
  addMessage: (message) => ApiUtils.responseParser(Axios.post('/web/v1/messages', message)),
  deleteMessage: (message) => Axios.delete('/web/v1/messages/' + message.id).then(() => null)
};
